import React from 'react'
import { Outlet } from 'react-router-dom'

import { FormSubmissionReportPage, FormSubmissionListPage, FormSubmissionDetailPage } from './pages'

export const routes = {
  user: [
    {
      path: 'relatorios',
      label: 'Relatórios',
      element: <Outlet />,
      children: [
        {
          path: ':formSubmissionId',
          label: ({ formSubmissionId }) => `Relatório #${formSubmissionId}`,
          element: <FormSubmissionReportPage />
        }
      ]
    }
  ],
  admin: [
    {
      path: 'relatorios',
      label: 'Relatórios',
      element: <Outlet />,
      children: [
        { path: '', label: 'Relatórios', element: <FormSubmissionListPage /> },
        {
          path: ':formSubmissionId',
          label: ({ formSubmissionId }) => `Relatório #${formSubmissionId}`,
          element: <FormSubmissionDetailPage />
        }
      ]
    }
  ]
}
